import ConstraintPanel from './ConstraintPanel';
import ControlPanel from './ControlPanel';
import MotionViewer from './MotionViewer';

export default function BmmPrototype() {
  return (
    <div className="bg-secondary flex h-[calc(100vh-120px)] w-full">
      <div className="border-primary bg-primary flex w-80 shrink-0 flex-col gap-0 overflow-y-auto border-r p-4">
        <ControlPanel />
        <div className="mt-4">
          <ConstraintPanel />
        </div>
      </div>

      <div className="flex-1">
        <MotionViewer />
      </div>
    </div>
  );
}
